import { Subject } from '../types';

export const TOPIC_SUGGESTIONS: Record<Subject, string[]> = {
    [Subject.MATH]: [
        "Addition & Subtraction",
        "Multiplication Tables",
        "Long Division",
        "Fractions",
        "Decimals",
        "Percentages",
        "Geometry Shapes",
        "Area and Perimeter",
        "Volume and Surface Area",
        "Algebraic Expressions",
        "Linear Equations",
        "Probability",
        "Statistics & Mean/Median/Mode",
        "Ratios and Proportions",
        "Exponents and Roots",
        "Order of Operations (PEMDAS)",
        "Coordinate Plane",
        "Graphing Linear Equations",
        "Pythagorean Theorem",
        "Word Problems"
    ],
    [Subject.SCIENCE]: [
        "Solar System & Planets",
        "Photosynthesis",
        "Water Cycle",
        "States of Matter",
        "Force and Motion",
        "Simple Machines",
        "Ecosystems & Food Chains",
        "Human Body Systems",
        "Cells and Organelles",
        "Genetics & Heredity",
        "Periodic Table of Elements",
        "Chemical Reactions",
        "Electricity and Magnetism",
        "Light and Sound Waves",
        "Plate Tectonics",
        "Rock Cycle",
        "Weather and Climate",
        "Renewable Energy",
        "Scientific Method",
        "Atoms and Molecules"
    ],
    [Subject.LANGUAGE_ARTS]: [
        "Parts of Speech (Nouns, Verbs, etc.)",
        "Sentence Structure",
        "Punctuation Rules",
        "Capitalization",
        "Spelling Patterns",
        "Vocabulary & Synonyms/Antonyms",
        "Reading Comprehension",
        "Main Idea & Details",
        "Cause and Effect",
        "Fact vs. Opinion",
        "Figurative Language (Similes, Metaphors)",
        "Poetry Elements",
        "Story Elements (Plot, Setting, Character)",
        "Types of Writing (Persuasive, Narrative)",
        "Prefixes and Suffixes",
        "Greek and Latin Roots",
        "Idioms",
        "Homophones",
        "Context Clues",
        "Literary Devices"
    ],
    [Subject.SOCIAL_STUDIES]: [
        "American Revolution",
        "US Constitution & Bill of Rights",
        "Branches of Government",
        "Civil War",
        "Westward Expansion",
        "Ancient Egypt",
        "Ancient Greece",
        "Ancient Rome",
        "World Geography",
        "US States and Capitals",
        "Native American Tribes",
        "Explorers and Colonization",
        "Industrial Revolution",
        "Civil Rights Movement",
        "World War I",
        "World War II",
        "Economics Basics (Supply & Demand)",
        "Maps and Globes",
        "Citizenship & Civic Duties",
        "Presidents of the United States"
    ]
};
